<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div class="form-orders">
    <b-tooltip
      v-if="showTooltipTaxHint && !isSelectedAnyTaxes"
      :show="showTooltipTaxHint"
      triggers="hover focus blur"
      target="tooltip-tax-hint-1"
      placement="top"
    >
      {{ $t('message.pickwhthere') }}
    </b-tooltip>
    <div
      class="d-none d-md-flex mb-2"
      style="overflow: hidden;height: 21px;">
      <div class="col-sku">
        <strong class="text-secondary-light">{{ $t('message.productorservice') }}</strong>
      </div>
      <div class="col-detail">
        <strong class="text-secondary-light">{{ $t('message.description') }}</strong>
      </div>
      <div class="col-qty text-right">
        <strong class="text-secondary-light">{{ $t('message.quantity') }}</strong>
      </div>
      <div class="col-price text-right">
        <strong class="text-secondary-light">{{ $t('message.price') }}</strong>
      </div>
      <div
        v-if="!hideFields.includes('discount')"
        class="col-discount text-right">
        <strong class="text-secondary-light">
          {{ $t('message.discount') }}
        </strong>
      </div>
      <div
        v-if="!hideFields.includes('tax')"
        class="col-tax text-right">
        <strong class="text-secondary-light">{{ $t('message.taxes') }}</strong>
        <i
          v-b-popover.hover.top="$t('message.advisetosetuptax')"
          :title="$t('message.advise')"
          class="fas fa-info-circle text-secondary-light"
        />
      </div>
      <div class="col-subtotal text-right">
        <strong class="text-secondary-light">{{ $t('message.subtotal') }}</strong>
      </div>
      <div
        v-if="!disabled"
        class="col-delete"/>
    </div>
    <div
      v-for="(item, index) in data"
      v-if="ready"
      class="d-flex flex-column flex-md-row form-order"
      @click="clickAtSingleList(index)">
      <div
        class="col-sku mb-2"
        style="height: 38px;">
        <div class="d-flex">
          <div style="flex: 1;">
            <template v-if="show_selectize[index] == true">
              <vue-bootstrap-autocomplete
                v-if="!disabled"
                v-model="item.queryProductName"
                :data="(() => {
                  return !item.sku_id && !item.is_saving_product
                    ? [
                      {
                        text: '',
                        sku_code: '',
                        value: '',
                      },
                      ...optionSkus
                    ]
                    : []
                })()"
                :serializer="(item) => item.text + ' ' + (item.sku_code || '')"
                :minMatchingChars="1"
                :maxMatches="10"
                :placeholder="createAble ? $t('placeholder.selectorcreate') : $t('placeholder.selectitem')"
                :loading="item.selectize.loading"
                :state="(() => {
                  if(item.selectize.trickValidation > 0) {
                    return !item.sku_id ? false : null
                  } else {
                    return null
                  }
                })()"
                :disabled="item.is_saving_product"
                @input="($event) => {
                  data[index].selectize.loading = true
                  lookupProducts(index, $event)
                }"
                @hit="handleSelectProduct(index, $event)"
                @blur="handleBlurProduct(index, $event)"
                @inputBlur="handleInputBlurProduct(index, $event)"
                @keydown="handleKeydownProduct(index, $event)"
                @keyup="handleKeyupProduct(index, $event)"
              >
                <template
                  v-if="item.queryProductName"
                  slot="create"
                  slot-scope="{ data, htmlText }">
                  <div
                    style="cursor: pointer;"
                    @mousedown="onAddedSku(item.queryProductName)"
                  >
                    <span class="text-success">
                      <i class="fas fa-plus"/>
                      {{ $t('message.addnewproduct') }}
                    </span>
                    <span style="color: #8f9295;">
                      {{ item.queryProductName }}
                    </span>
                  </div>
                </template>
                <template
                  slot="suggestion"
                  slot-scope="{ data, htmlText }">
                  <div class="d-flex align-items-center">
                    <img
                      :src="productImage(data.value)"
                      style="width: 40px; height: 40px; border-radius: 0.25rem;"
                    >
                    <div class="d-flex flex-column">
                      <span
                        class="ml-4"
                        v-html="data.text"/>
                      <span
                        class="ml-4"
                        style="font-size: 11px;"
                        v-html="data.sku_code"/>
                    </div>
                  </div>
                </template>
              </vue-bootstrap-autocomplete>
              <input
                v-else
                :disabled="disabled"
                :value="getSku(item.sku_id) ? getSku(item.sku_id).product_name : null"
                type="text"
                class="form-control">
            </template>
          </div>
        </div>
      </div>
      <div class="col-detail mb-3">
        <b-form-textarea
          :disabled="item.sku_id.length == 0 || disabled"
          :placeholder="$t('placeholder.description')"
          :noResize="true"
          :maxRows="1"
          v-model="item.description" />
      </div>
      <div
        class="col-qty mb-2"
        style="position: relative;">
        <BaseInputGroupMobile>
          <template #label>
            {{ $t('message.quantity') }}
          </template>
          <template #input>
            <input
              :ref="'input-qty-' + index"
              :disabled="item.sku_id.length == 0 || disabled"
              v-model="item.quantity"
              type="text"
              class="form-control text-right text-select-all quantity"
              placeholder=""
              @keypress="numberOnly"
              @keyup="item.quantity = setToValidNumber(item.quantity)"
              @focus="handleInputQtyFocus(item, index)"
              @blur="handleInputQtyBlur(item, index); item.quantity = setToCustomDigitsNumber(item.quantity);">
          </template>
        </BaseInputGroupMobile>
        <div
          v-if="item.sku_id.length > 0 && !disabled && getSkuInfoBySkuId(item.sku_id)"
          :ref="'modal-current-stock-' + index"
          class="modal-current-stock">
          <div class="container p-0">
            <section
              v-for="(stock, index_) in getSkuInfoBySkuId(item.sku_id).stocks"
              v-if="getWarehouseInfo(stock.warehouse_id)"
              class="row mb-1"
            >
              <div class="col-12">
                <section-title
                  :title="getWarehouseInfo(stock.warehouse_id).warehouse_name"
                  fontweight="bold"/>
                <div class="form-row">
                  <div class="col-12">
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div
                          class="input-group-text"
                          style="min-width: 90px;">{{ $t('apps.inventory.message.instock') }}</div>
                      </div>
                      <input
                        :value="stock.instock"
                        type="text"
                        class="form-control form-control-sm text-right"
                        disabled>
                    </div>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div
                          class="input-group-text"
                          style="min-width: 90px;">{{ $t('apps.inventory.message.reserved') }}</div>
                      </div>
                      <input
                        :value="stock.reserved"
                        type="text"
                        class="form-control form-control-sm text-right"
                        disabled>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="col-price mb-2">
        <BaseInputGroupMobile>
          <template #label>
            {{ $t('message.price') }}
          </template>
          <template #input>
            <input
              :disabled="item.sku_id.length == 0 || disabled"
              v-model="item.price"
              type="text"
              class="form-control text-right text-select-all"
              placeholder=""
              @keypress="numberOnly"
              @keyup="item.price = setToValidNumber(item.price)"
              @blur="item.price = setToCustomDigitsNumber(item.price)">
          </template>
        </BaseInputGroupMobile>
      </div>
      <div
        v-if="!hideFields.includes('discount')"
        class="col-discount mb-2">
        <div class="input-group">
          <div class="input-group-prepend d-flex d-md-none">
            <span
              class="input-group-text"
              style="min-width: 80px;">
              {{ $t('message.discount') }}
            </span>
          </div>
          <input
            :disabled="item.sku_id.length == 0 || disabled"
            v-model="item.discounts[0].value_amount"
            type="text"
            class="form-control text-right text-select-all"
            style="border-right: none;padding: 0 8px 0 0;"
            @keypress="numberOnly"
            @keyup="item.discounts[0].value_amount = setToValidNumber(item.discounts[0].value_amount)"
            @focus="isFocusInputDiscount = true; clickAtSingleList(index);"
            @blur="isFocusInputDiscount = false; item.discounts[0].value_amount = setToCustomDigitsNumber(item.discounts[0].value_amount)">
          <div class="input-group-prepend">
            <button
              :class="[{'btn-web': isFocusInputDiscount && focusAtIndex == index && isReadyToEditDiscount}]"
              :disabled="item.sku_id.length == 0 || disabled"
              style="opacity: 1 !important;"
              class="btn btn-discount"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              @focus="isFocusInputDiscount = true"
              @blur="isFocusInputDiscount = false"
              @click="isFocusInputDiscount = true; clickAtSingleList(index);">
              <span v-if="item.discounts[0].value_type == 'percentage'">
                %
                <i
                  v-if="isFocusInputDiscount && focusAtIndex == index && isReadyToEditDiscount"
                  class="fas fa-caret-down"/>
              </span>
              <span v-else>
                {{ currency }}
                <i
                  v-if="isFocusInputDiscount && focusAtIndex == index && isReadyToEditDiscount"
                  class="fas fa-caret-down"/>
              </span>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <a
                class="dropdown-item"
                @click="item.discounts[0].value_type = 'percentage'">%</a>
              <a
                class="dropdown-item"
                @click="item.discounts[0].value_type = 'number'">{{ currency }}</a>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!hideFields.includes('tax')"
        :id="`tooltip-tax-hint-${index+1}`"
        class="col-tax mb-2">
        <BaseInputGroupMobile>
          <template #label>
            {{ $t('message.taxes') }}
          </template>
          <template #input>
            <div class="flex-grow-1">
              <MultipleSelect
                v-model="item.selectedTaxIds"
                :options="taxOptions"
                :multiple="true"
                :disabled="item.sku_id.length == 0 || disabled"
                @change="handleChangeTax($event, index)"
              />
            </div>
          </template>
        </BaseInputGroupMobile>
      </div>
      <div class="col-subtotal mb-2">
        <BaseInputGroupMobile>
          <template #label>
            {{ $t('message.subtotal') }}
          </template>
          <template #input>
            <BaseInputNumber
              :value="getOrderTotal(item)"
              type="text"
              class="form-control text-right"
              disabled
              placeholder=""/>
          </template>
        </BaseInputGroupMobile>
      </div>
      <div
        v-if="!disabled"
        class="col-delete mb-2 text-center">
        <button
          class="btn col-12"
          @click="del(index)">
          <i class="far fa-trash-alt"/>
        </button>
      </div>
    </div>
    <section
      v-if="!disabled"
      class="mb-3">
      <button
        class="btn"
        @click="add()">{{ $t('button.addproduct') }}</button>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { TAX_FORM_TYPE } from '@/helpers/enum'
import MultipleSelect from '@/components/custom/MultipleSelect'
import { getDisplayTaxNameRate, getMasterDataText } from '../../helpers'
import orderAutocompleteAccountingMixin from '../../mixins/orderAutocompleteAccounting'
import BaseInputGroupMobile from '../base/BaseInputGroupMobile.vue'
import { getSkuNameWithUnit } from '../../lib/v-calendar/utils/helpers'

export default {
  mixins: [orderAutocompleteAccountingMixin],
  components: {
    MultipleSelect,
    BaseInputGroupMobile,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
    },
    validation: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    createAble: {
      type: Boolean,
      default: true,
    },
    showProductImage: {
      type: Boolean,
      default: true,
    },
    showTooltipTaxHint: {
      type: Boolean,
      default: false,
    },
    hideFields: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      ready: false,

      productsAvailable: [],

      optionSkus: [],
      updateOptionSkus: null,
      loadingSkus: false,
      trickValidationSkus: 0,

      focusAtIndex: 0,
      isFocusOnInput: false,

      isFocusInputDiscount: false,
      isReadyToEditDiscount: false,

      discountType: 'percentage',

      show_selectize: [],
    }
  },
  computed: {
    ...mapGetters({
      products: 'getProducts',
      vat: 'getVat',
      currency: 'getCurrency',
      getSkuInfoBySkuId: 'getSkuInfoBySkuId',
      getWarehouseInfo: 'getWarehouseInfo',
      warehouses: 'getWarehouses',
      getProductInfoBySkuId: 'getProductInfoBySkuId',
      defaultImages: 'getDefaultImages',
      taxes: 'getTaxes',
      getProductIdBySkuId: 'getProductIdBySkuId',
    }),
    isSelectedAnyTaxes() {
      return this.data.some((item) => item.selectedTaxIds.length > 0)
    },
    taxOptions() {
      return this.taxes
        .filter((tax) => {
          if (this.type == 'so' || this.type == 'in' || this.type == 'rt') {
            return tax.is_for_sale
          } else if (this.type == 'po' || this.type == 'pr') {
            return tax.is_for_purchase
          }
          return true
        })
        .map((tax) => {
          return {
            value: tax.tax_id,
            text: getDisplayTaxNameRate(getMasterDataText(tax.tax_name, this.$t), tax.amount),
          }
        })
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    products: function () {
      this.setProductsAvailable()
    },
    validation () {
      this.validateform()
    },
    data () {
      this.isFocusOnInput = false
    },
    isFocusInputDiscount (after, before) {
      let isReady = after
      let that = this
      if (isReady) {
        setTimeout(() => {
          that.isReadyToEditDiscount = true
        }, 150)
      } else {
        that.isReadyToEditDiscount = false
      }
    },
  },
  created: async function () {
    // get warehouses
    if (this.warehouses.length == 0) {
      this.$store.dispatch('getWarehouses')
    }

    // set dataset
    this.setProductsAvailable()

    // set ready
    this.ready = true

    // default
    if (!this.disabled && this.data.length == 0) {
      this.add()
      this.add()
    } else {
      for (let i = 0; i < this.data.length; i++) {
        this.data[i].queryProductName = this.data[i].item
        this.data[i].image = ''
        this.data[i].is_saving_product = false
      }
    }

    // set show_selectize
    if (this.show_selectize.length == 0) {
      this.data.map(object => {
        this.show_selectize.push(true)
      })
    }
  },
  methods: {
    inputClick (index) {
      let isLast = index == this.data.length - 1
      if (isLast) {
        this.add()
      }
    },
    add () {
      var that = this
      that.focusAtIndex = that.data.length
      that.data.push({
        sku_id: '',
        item: '',
        description: '',
        quantity: this.setToCustomDigitsNumber(0),
        price: this.setToCustomDigitsNumber(0),
        cost: null,
        discounts: [
          {
            value_type: 'percentage',
            value_amount: 0,
          },
        ],
        taxes: [],
        selectedTaxIds: [],
        selectize: {
          loading: false,
          updateOption: null,
          trickValidation: 0,
        },
        queryProductName: '',
        image: '',
        is_saving_product: false,
      })
      that.show_selectize.push(true)
    },
    del (index) {
      this.data.splice(index, 1)

      let that = this
      if (that.data.length == 0) {
        setTimeout(() => {
          that.add()
        }, 100)
      }
    },
    getData () {
      var data = _.cloneDeep(this.data)

      var newData = []

      // remove key, data we don't need
      for (let i in data) {
        let order = data[i]
        if (order.sku_id) {
          newData.push({
            sku_id: order.sku_id,
            item: order.item,
            description: order.description,
            quantity: parseFloat(order.quantity) || 0,
            price: parseFloat(order.price) || 0,
            cost: order.cost != null ? parseFloat(order.cost) : null,
            taxes: order.taxes,
            discounts: order.discounts
              .map((discount) => ({
                ...discount,
                type: 'general',
                value_amount: parseFloat(discount.value_amount),
              }))
              .filter((discount) => discount.value_amount != 0),
          })
        }
      }

      return newData
    },
    isValid () {
      let data = this.getData()

      if (data.length == 0) {
        this.data[0].selectize.trickValidation++
      }

      return data.length != 0
    },
    validateform () {
      var data = null
      var isValid = false
      if (this.isValid()) {
        data = this.getData()
        isValid = true
      }
      this.$emit('submit', isValid, data)
    },
    onPickedSku (value, index) {
      let sku_id = value
      let sku = this.getSku(sku_id)
      if (sku) {
        let data = this.data.find((order, index) => index == this.focusAtIndex)
        const productId = this.getProductIdBySkuId(sku_id)
        this.focusAtIndex++
        if (data) {
          if (data.sku_id.length > 0 && this.isFocusOnInput) {
            data.item = sku.product_name
            data.description = getSkuNameWithUnit(sku.product_name, sku.unit)
            data.quantity = this.setToCustomDigitsNumber(1)
            if (this.type == 'so' || this.type == 'in' || this.type == 'rt') {
              data.price = this.setToCustomDigitsNumber(sku.price)
            } else if (this.type == 'po' || this.type == 'pr') {
              data.price = this.setToCustomDigitsNumber(0)
            } else {
              data.price = this.setToCustomDigitsNumber(0)
            }
            data.cost = sku.cost
            const taxIds = this.taxes.reduce((acc, cur) => {
              cur.assign.forEach((assignItem) => {
                const isApplyForThis = (() => {
                  if (this.type == 'so' || this.type == 'in' || this.type == 'rt') {
                    return cur.is_for_sale
                  } else if (this.type == 'po' || this.type == 'pr') {
                    return cur.is_for_purchase
                  }
                })()
                if (assignItem.product_id === productId && isApplyForThis && cur.is_active) {
                  acc.push(cur.tax_id)
                }
              })
              return acc
            }, [])
            data.selectedTaxIds = [...taxIds]
            this.handleChangeTax(data.selectedTaxIds, index)
          }
        }
      }
    },
    async onAddedSku (value) {
      let data = this.data.find((order, index) => index == this.focusAtIndex)
      let sku = this.getSku(value)
      if (sku == null) {
        data.selectize.loading = true
        data.is_saving_product = true
        this.optionSkus = []

        let res = await this.$store.dispatch('insertProduct', {
          product_name: value,
          type: 'product',
          assign_inventory: false,
          assign_pos: false,
        })

        if (res.success) {
          let product = res.data
          let sku_id = product.skus[0].sku_id

          // update data
          data.sku_id = sku_id
          data.item = data.item || value
          data.description = value
          data.quantity = this.setToCustomDigitsNumber(1)
          data.price = this.setToCustomDigitsNumber(0)
          data.selectize.updateOption = {
            text: value,
            value: sku_id,
            picked: true,
          }

          // hide loading selectize
          data.selectize.loading = false
          data.is_saving_product = false
          // finish loading
          this.showFinish(this.$Progress)
          // refresh selectize
          var fake = []
          this.data.map((object, index) => { if (object.sku_id == '') { fake.push(false) } else { fake.push(true) } })
          this.show_selectize = fake
          this.$nextTick(function () {
            fake = []
            this.data.map((object, index) => { fake.push(true) })
            this.show_selectize = fake
          })
        }
      }
    },
    setOptionSkus () {
      this.optionSkus = []
      for (let i in this.productsAvailable) {
        let item = this.productsAvailable[i]
        if (item.product_name) {
          this.optionSkus.push({
            text: item.product_name,
            sku_code: item.sku_code,
            value: item.sku_id,
          })
        }
      }
    },
    getSku (sku_id) {
      for (let i in this.productsAvailable) {
        let item = this.productsAvailable[i]
        if (item.sku_id == sku_id) {
          return item
        }
      }
      return null
    },
    getOrderTotal (order) {
      const total = this.getTotal([order])
      return this.currencyFormatter(total.sub, { code: this.currency, symbol: '' }).replace(/,/g, '')
    },
    clickAtSingleList (index) {
      this.focusAtIndex = index
      this.isFocusOnInput = true
    },
    setProductsAvailable () {
      this.productsAvailable = []
      for (let i in this.products) {
        let product = this.products[i]
        for (let j in product.prices) {
          let price = product.prices[j]
          this.productsAvailable.push({
            product_name: this.getProductFullName(product.product_name, price.attributes),
            sku_id: price.sku_id,
            price: price.price || 0,
            cost: price.cost || 0,
            unit: product.unit,
            sku_code: price.sku_code,
          })
        }
      }
      this.setOptionSkus()
    },
    handleInputQtyFocus (order, index) {
      let sku = this.getSkuInfoBySkuId(order.sku_id)
      let stocks = sku ? sku.stocks : []
      let haveStock = stocks.length > 0

      if (haveStock) {
        let $el = this.$refs['input-qty-' + index]
        if ($el !== undefined) {
          let position = $el[0].getBoundingClientRect()
          let $elCurrentStock = this.$refs['modal-current-stock-' + index]
          if ($elCurrentStock !== undefined) {
            $elCurrentStock[0].style.display = 'block'
            $elCurrentStock[0].style.top = -$elCurrentStock[0].offsetHeight - 9 + 'px'
          }
        }
      }
    },
    handleInputQtyBlur (order, index) {
      let $elCurrentStock = this.$refs['modal-current-stock-' + index]
      if ($elCurrentStock !== undefined) {
        $elCurrentStock[0].style.display = 'none'
      }
    },
    productImage (skuId) {
      if (!skuId) return this.defaultImages.product
      const product = this.getProductInfoBySkuId(skuId)
      return (product && product.images.thumbnail) || this.defaultImages.product
    },
    handleChangeTax(values, index) {
      if (values.length) {
        this.data[index].taxes = values.map((taxId) => {
          const taxInfo = this.taxes.find((taxItem) => taxItem.tax_id === taxId)
          return {
            ...taxInfo,
            form_type: taxInfo.form_type,
            name: taxInfo.tax_name,
            type: taxInfo.type,
            amount: taxInfo.amount,
          }
        })
      } else {
        this.data[index].taxes = []
      }
    },
  },
}
</script>

<style scoped>
  .form-orders textarea {
    min-height: 35px;
  }
  .modal-current-stock {
    position: absolute;
    top: 0;
    left: 5px;
    z-index: 99999;
    width: 250px;
    height: auto;
    background: #fff;
    padding: 10px 12px 12px 12px;
    box-shadow: 0 4px 16px -4px rgba(9,45,66,.25), 0 0 0 1px rgba(9,45,66,.08);
    border-radius: .25rem;
    display: none;
  }
  .modal-current-stock section:last-of-type {
    margin-bottom: 0!important;
  }
  .modal-current-stock .container section:last-of-type .input-group:last-of-type {
    margin-bottom: 0 !important;
  }
  .btn-discount {
    min-width: 40px;
    border: 1px solid #ced4da;
    border-radius: 0 .25rem .25rem 0 !important;
    padding-right: 2px;
    padding-left: 0px;
    font-size: 11px !important;
    min-height: 35px;
    line-height: 1px;
    opacity: 1;
    box-shadow: none !important;
  }

  .col-sku {
    flex: 1;
    margin-right: 10px;
  }
  .col-detail {
    flex: 1;
    margin-right: 10px;
  }
  .col-qty {
    width: 90px;
    margin-right: 10px;
  }
  .col-price {
    width: 100px;
    margin-right: 10px;
  }
  .col-discount {
    width: 100px;
    margin-right: 10px;
  }
  .col-discount >>> input.form-control {
    border-radius: 0.25rem 0 0 0.25rem !important;
  }
  .col-tax {
    width: 120px;
    margin-right: 10px;
  }
  .col-tax >>> button.dropdown-toggle {
    border-radius: 0.25rem 0 0 0.25rem !important;
  }
  .col-subtotal {
    width: 120px;
  }
  .col-delete {
    margin-left: 10px;
    width: 50px;
  }

  @media (max-width: 767.98px) {
    .form-order {
      padding: 8px 5px;
      border-radius: 5px;
      background: #F5F5F5;
      margin-bottom: .5rem;
    }
    .col-sku {
      width: auto;
      flex: 1;
      margin-right: 0;
    }
    .col-detail {
      width: auto;
      flex: 1;
      margin-right: 0;
      margin-bottom: .5rem !important;
    }
    .col-qty {
      width: auto;
      flex: 1;
      margin-right: 0;
    }
    .col-price {
      width: auto;
      flex: 1;
      margin-right: 0;
    }
    .col-discount {
      width: auto;
      flex: 1;
      margin-right: 0;
    }
    .col-discount >>> input.form-control {
      border-radius: 0 !important;
    }
    .col-tax {
      width: auto;
      flex: 1;
      margin-right: 0;
    }
    .col-tax >>> .dropdown.bootstrap-select, .col-tax >>> button.dropdown-toggle  {
      border-radius: 0 0.25rem 0.25rem 0 !important;
    }
    .col-tax .flex-grow-1 {
      max-width: calc(100% - 80px);
    }
    .col-subtotal {
      width: auto;
      flex: 1;
      margin-right: 0;
    }
    .col-delete {
      width: auto;
      flex: 1;
      margin-right: 0;
    }
    .col-delete {
      margin-left: 0;
      margin-bottom: 0 !important;
    }
  }
</style>

<style>
  #content .form-orders textarea:not(:focus) {
    height: 35px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/custom/Order.vue